import {
  Component, ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output, TemplateRef,
  ViewChild
} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {CancelButtonComponent} from "../cancel-button/cancel-button.component";
import {DynamicFormComponent} from "../dynamic-form/dynamic-form.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {FieldComponent} from "../fields/field/field.component";
import {FormGeneratorService} from "../fields/form-generator.service";
import {QuestionControlService} from "../fields/question-control.service";
import {FieldDefinition} from "../../../model/field-definition";

@Component({
    selector: 'app-dynamic-modal-form',
    imports: [
        CommonModule,
        CancelButtonComponent,
        DynamicFormComponent,
        FaIconComponent,
        ReactiveFormsModule,
        FieldComponent
    ],
    templateUrl: './dynamic-modal-form.component.html',
    styleUrl: './dynamic-modal-form.component.scss'
})
export class DynamicModalFormComponent {
  @ViewChild('modal', {static: true}) modalTemplate: ElementRef;
  @ContentChild(TemplateRef) template: TemplateRef<any>;

  @Input() title: string;
  @Input() actions: {
    label: string,
    class: string,
    icon: string,
    submit?: boolean,
    longLabel?: string,
    condition?: (form: FormGroup) => boolean,
    action?: (form: FormGroup, modal: NgbModalRef) => void
  }[];
  @Input() doOnChange: (values: any, form: FormGroup, questions: FieldDefinition<any>[]) => void = () => {
  };
  @Input() generator: FormGeneratorService;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  @Output()
  onSubmit = new EventEmitter<any>();
  @Output()
  onCancel = new EventEmitter<any>();

  @Input()
  set object(val: any) {
    if (val === undefined) return;
    this.$object = val;
    if (!this.generator) {
      this.openModal();
    } else {
      this.generator.getQuestions(val).subscribe(q => {
        this.questions = q;
        this.form = this.qcs.toFormGroup(this.questions, this.doOnChange);
        this.form.addControl('id', new FormControl(val?.id))
        this.openModal();
      });
    }
  }

  $object: any;
  questions: FieldDefinition<any>[] = [];
  form: FormGroup = new FormGroup<any>([]);

  constructor(private modalService: NgbModal, private qcs: QuestionControlService) {
  }

  openModal(): void {
    this.modalService.open(this.modalTemplate, {size: this.size, backdrop: 'static'}).result.then(() => {
      this.onSubmit.emit(this.form.getRawValue());
    }, () => {
      this.onCancel.emit();
    });
  }

  doAction(action: (form: FormGroup, modal: NgbModalRef) => void, form: FormGroup, modal: any): void {
    if (action !== undefined) {
      action(form, modal);
    } else {
      modal.close();
    }
  }

  checkCondition(condition: (form: FormGroup) => boolean, form: FormGroup) {
    if (condition !== undefined) {
      return condition(form);
    } else {
      return true;
    }
  }
}
